module.exports = __webpack_public_path__ + "img/Ben.1593ab27.jpg";